import {StandardUserRemoval} from 'app/services/standard-user-removal';
import {StandardFamiliarizationUser} from 'app/models/standard-user.model';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';
import { isStandardVersionConflict, savedStandardVersion } from 'app/services/standard-version';
import { StandardChangeLog } from 'app/services/standard-change-log';
import { TreeGroupPosBlockComponent } from 'app/content-page/admin/create-operating-standard/tree-group-pos-service/tree-group-pos-block/tree-group-pos-block.component';
import { AfterViewInit, Component, ElementRef, HostListener, Input, OnChanges, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {isStandardsPhone} from 'app/content-page/my-standards/standards-viewport';
import { Standard } from 'app/models/standard.model';
import { STANDARD_FILE_METADATA } from 'app/models/standard-files.model';
import { HttpResponse } from '@angular/common/http';
import { NewBlank } from '../../../../models/new-blank.model';
import { StandardType } from '../../../../models/standard-type.model';
import { PrefixService } from 'app/services/prefix.service';
import { StepsControllerService } from '../../../../services/steps-controller.service';
import { StandardTypesService } from '../../../../services/standard-types.service';
import { AdminService } from '../../../../services/admin.service';
import { UserService } from '../../../../services/user.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationPopupComponent } from '../../../views/view-group/popups/confirmation-popup/confirmation-popup.component';
import { EditQuestionComponent } from './edit-question-step-popup/edit-question.component';
import { ApiConnectService } from '../../../../services/api-connect.service';
import { Question } from '../../../../models/question.model';
import { StepTempControllerService } from '../../../../services/step-temp-controller.service';
import { StepTestingService } from '../opst-step-six/step-create-testing/step-testing.service';
import { Router } from '@angular/router';
import { AddChanglogComponent } from './add-changlog/add-changlog.component';
import * as moment from 'moment';
import { TreeGroupPosService } from '../tree-group-pos-service/tree-group-pos.service';
import { StandardDocumentContext, ViewDocxService, storeDocumentContext } from 'app/services/view-docx.service';
import { downloadCatalogFile } from 'app/content-page/my-standards/standard-catalog-state';
import { ViewDocxComponent } from '../../../views/view-docx/view-docx.component';
import { AddNewQuestionsComponent } from '../../../views/view-standard/popups/add-new-questions/add-new-questions.component';
import { Answer } from '../../../../models/answer.model';
import { User } from '../../../../models/user.model';
import { StepConfirmPopupComponent } from '../step-confirm-popup/step-confirm-popup.component';
import { EditStandardNumberPopupComponent } from './edit-standard-number-popup/edit-standard-number-popup.component';
import { TranslateService } from '@ngx-translate/core';
import {
  StandardAiQuestionGenerationStatus,
  StandardAiQuestionLanguage
} from '../../../../models/standard-ai-question-generation.model';

const CHANGE_LOG_CONTINUE = 'continue';
const EMPTY_CHANGE_LOG = '';
const HTTP_OK = 200;
const FILE_RU_DOC = 'RU_DOC';
const FILE_RU_PPT = 'RU_PPT';
const FILE_RU_PDF = 'RU_PDF';
const FILE_EN_DOC = 'EN_DOC';
const FILE_EN_PPT = 'EN_PPT';
const FILE_EN_PDF = 'EN_PDF';
const LANGUAGE_RU = 'Ru';
const LANGUAGE_EN = 'En';
const QUESTION_TEXT_PREFIX = 'questionText';
const RIGHT_ANSWER_PREFIX = 'rightAnswer';
const ANSWER_PREFIXES = ['answerOne', 'answerTwo', 'answerThree'];
const ANSWER_INDEX = { '1': 0, '2': 1, '3': 2 };
const FIRST_ANSWERS = 0;
const DEFAULT_FAMILIARIZATION_DAYS = 5;
const TEMP_DOCUMENT_LINK_FIELD = 'ruFileLink';
const TEMP_PRESENTATION_FIELD = 'ruPptId';
const EDITING_STATUS = 'ON_EDITING';
const ACTIVE_PIN_STATUS = 'ACTIVE';
const INACTIVE_PIN_STATUS = 'INACTIVE';
const AI_LANGUAGE_RUSSIAN: StandardAiQuestionLanguage = 'RUSSIAN';
const AI_STATUS_KEY_PREFIX = 'STANDARD_AI_QUESTIONS_STATUS_';
const STANDARD_LANGUAGE_ENGLISH = 'english';
const EMPTY_READ_TEXT = '';
const STANDARD_DATE_FORMAT = 'DD.MM.YYYY';
const WIZARD_FOOTER_CLASS = 'card-footer';
const FIRST_WIZARD_FOOTER = 0;
const WIZARD_FOOTER_COUNT = 2;
const WIZARD_HOST_TAG = 'APP-CREATE-OPERATING-STANDARD';
const CONFIRM_RESULT = 'ok';
const DELETE_STANDARD_CONFIRM = 'DO_YOU_WANT_TO_DELETE_THIS_STANDARD';
const TEMP_FILE_FIELDS = { RU_DOC: 'ruDocId', RU_PPT: 'ruPptId', RU_PDF: 'ruPdfId', EN_DOC: 'enDocId', EN_PPT: 'enPptId', EN_PDF: 'enPdfId' };
const FIRST_SELECTED_FILE = 0;
const FILE_TYPE_INDEX = 0;
const FILE_ID_INDEX = 1;
const DOCUMENT_EXTENSION_OFFSET = 6;
const DOCUMENT_EXTENSION = '.docx';
const STANDARD_LIST_ROUTES = { admin: '/dashboard/admin/standards-management-admin', adminHead: '/dashboard/admin/all-standards-head',
  head: '/dashboard/admin/all-standards-head-only', employee: '/dashboard/standards' };
const DELETE_BLANK_FILE_CONFIRM = 'DYWTDTBF';
const DELETE_BLANK_CONFIRM = 'DYWTDTB';
const DELETE_QUESTION_CONFIRM = 'DYWTDTQ';
const BLANK_NUMBER_SEPARATOR = '_blank_';
const BLANK_FILE_FIELD = 'file';
const QUESTION_LANGUAGE_ENGLISH = 'ENGLISH';
const ITEM_NOT_FOUND = -1;
const NO_ITEMS = 0;
const ONE_ITEM = 1;
const FILE_LANGUAGE_LABELS = { Ru: 'SKILL_LEARNING_AI_STATS_STANDARD_LANGUAGE_RUSSIAN', En: 'SKILL_LEARNING_AI_STATS_STANDARD_LANGUAGE_ENGLISH' };
const READER_MODAL_SIZE = 'lg';
const READER_MODAL_BACKDROP = 'static';
const DOWNLOAD_FILENAME_HEADER = 'filename';

interface StandardDisplayFiles {
  language: string;
  label: string;
  presentation: string;
  document: string;
  link: string;
  pdf: string;
}

@Component({
  selector: 'app-opst-step-eight',
  templateUrl: './opst-step-eight.component.html',
  styleUrls: ['./opst-step-eight.component.css']
})
export class OpstStepEightComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  @Input() readOnly = false;
  @Input() readStandard: Standard;
  readerMaterialFailed = false;
  isPhone = isStandardsPhone();
  private readerModal: NgbModalRef;

  @HostListener('window:resize') updateViewport(): void { this.isPhone = isStandardsPhone(); }

  get publishedPinStandardId(): string {
    if (this.readOnly) { return this.thisStandard ? this.thisStandard.id : null; }
    const parentId = this.stepsControllerService.getTempParrentID();
    if (parentId) { return parentId; }
    return this.thisStandard && (this.thisStandard.status === ACTIVE_PIN_STATUS || this.thisStandard.status === INACTIVE_PIN_STATUS)
      ? this.thisStandard.id : null;
  }

  get standardLanguage(): string {
    if (!this.readOnly) { return this.stepsControllerService.getLocalUserLanguage(); }
    return (this.thisStandard.language || EMPTY_READ_TEXT).toLowerCase() === STANDARD_LANGUAGE_ENGLISH ? LANGUAGE_EN : LANGUAGE_RU;
  }

  get showQuestionContent(): boolean { return !this.readOnly || this.isHead || this.isAdmin; }

  get displayQuestions(): Question[] {
    return this.readOnly && this.standardLanguage === LANGUAGE_EN ? this.thisStandard.questions.english : this.thisStandard.questions.russian;
  }

  get displayFiles(): StandardDisplayFiles[] {
    const russian = this.filesForLanguage(LANGUAGE_RU);
    if (!this.readOnly) { return [russian]; }
    return [russian, this.filesForLanguage(LANGUAGE_EN)].filter(file => !!(file.presentation || file.document || file.link || file.pdf));
  }

  get hasDisplayFiles(): boolean { return this.displayFiles.some(file => !!(file.presentation || file.document || file.link || file.pdf)); }

  private filesForLanguage(language: string): StandardDisplayFiles {
    const documentFields = STANDARD_FILE_METADATA[language === LANGUAGE_RU ? FILE_RU_DOC : FILE_EN_DOC];
    const presentationField = language === LANGUAGE_RU ? FILE_RU_PPT : FILE_EN_PPT;
    return { language, label: FILE_LANGUAGE_LABELS[language], link: this.thisStandard[documentFields.link],
      document: this.thisStandard[TEMP_FILE_FIELDS[language === LANGUAGE_RU ? FILE_RU_DOC : FILE_EN_DOC]] || (this.readOnly ? this.thisStandard[documentFields.field] : null),
      presentation: this.thisStandard[TEMP_FILE_FIELDS[presentationField]] || (this.readOnly ? this.thisStandard[STANDARD_FILE_METADATA[presentationField].field] : null),
      pdf: this.thisStandard[STANDARD_FILE_METADATA[language === LANGUAGE_RU ? FILE_RU_PDF : FILE_EN_PDF].field] };
  }

  trackDisplayFile(index: number, file: StandardDisplayFiles): string { return file.language; }
  trackDisplayQuestion(index: number): number { return index; }

  userRemoval = new StandardUserRemoval(this.adminService, this.modalService);

  @ViewChild(TreeGroupPosBlockComponent) private assignmentEditor: TreeGroupPosBlockComponent;
  @ViewChild('standardWindow') private standardWindow: ElementRef;
  versionConflict = false;
  reloadFailed = false;
  publicationPending = false;
  private publicationDestroyed$ = new Subject<void>();
  private publicationDestroyed = false;
  private publicationNote = EMPTY_CHANGE_LOG;
  private changeLogStorage = new StandardChangeLog();
  hasSaveAction = false;
  isLoaded = true;
  thisStandard: any;
  newBlanks: NewBlank[] = [];
  removedUsersIDList: any[] = [];
  okModifyMsg = false;
  daysForFamiliarization = 5;
  thisStandardList;
  usersAndGroups: any;
  stringDate: string;
  acknowledgementDays = 5;
  acknowledgementDaysTemp = null;
  showDiscussionBtn = false;
  showTable = false;
  isReadOnly = false;
  goBtnIsClicked = false;
  isLoadedStep = false;
  tableUsers: any;
  selectedType: StandardType;
  groupStandardId: string;
  users: any;
  groups: any;
  groupsHead: any;
  isUploadDisabled = false;
  newRuName = '';
  newEnName = '';
  newRuAn = '';
  newEnAn = '';
  formData: FormData = new FormData();
  selectedForExecute: any = [];
  selectedGroupForExecute: any = [];
  selectedPosForExecute: any = [];
  showUserFTable = true;
  listDelBlanks = [];

  foundUser = false;
  foundPos = false;
  foundGroup = false;
  foundUserConfirm = false;
  foundPosConfirm = false;
  foundGroupConfirm = false;

  // RUS
  isNewRuDoc = false;
  isNewRuPpt = false;
  isNewRuPdf = false;
  fileRuDoc: File = null;
  fileRuPpt: File = null;
  fileRuPdf: File = null;
  // ENG
  isNewEnDoc = false;
  isNewEnPpt = false;
  isNewEnPdf = false;
  fileEnDoc: File = null;
  fileEnPpt: File = null;
  fileEnPdf: File = null;

  globalQuestions: any = [];
  globalRusQuest: any = [];
  globalEngQuest: any = [];
  aiQuestionStatusByLanguage: { [language: string]: StandardAiQuestionGenerationStatus } = {};
  aiQuestionLoadingByLanguage: { [language: string]: boolean } = {};
  aiQuestionStatusLoadingByLanguage: { [language: string]: boolean } = {};
  aiQuestionStatusErrorByLanguage: { [language: string]: boolean } = {};
  aiQuestionGenerationErrorByLanguage: { [language: string]: boolean } = {};
  aiQuestionStatusVisibleByLanguage: { [language: string]: boolean } = {};
  private aiQuestionStatusHideTimers: { [language: string]: any } = {};
  disSaveBtn = false;

  successFMsg = false;
  errorFHMsg = false;
  errorUnknowMsg = false;
  showAddQuestions = false;
  showQestions = false;
  showDessiminStn = false;
  showFilesAndBlanks = false;
  showChangeLog = false;
  showChangeLogs = false;
  errorNoUsersMsg = false;
  errorMessage = false;
  user: User;
  isAdmin = false;
  isHead = false;
  isUser = false;
  flagNg = true;
  role;
  errorFHMsgPpt = false;
  errorFHMsgTxt = false;

  constructor(public prefixService: PrefixService,
    public stepsControllerService: StepsControllerService,
    public standardTypesService: StandardTypesService,
    private adminService: AdminService,
    private userService: UserService,
    public viewDocxService: ViewDocxService,
    private apiConnectService: ApiConnectService,
    private stepTempControllerService: StepTempControllerService,
    private modalService: NgbModal,
    private stepTestingService: StepTestingService,
    private router: Router,
    private treeGroupPosService: TreeGroupPosService,
    private translate: TranslateService) {
  }

  ngOnDestroy() {
    if (this.readerModal) { this.readerModal.dismiss(); }
    this.userRemoval.ngOnDestroy();
    this.publicationDestroyed = true;
    this.publicationDestroyed$.next();
    this.publicationDestroyed$.complete();
    this.clearAiQuestionStatusTimers();
    if (!this.readOnly) { this.stepsControllerService.leaveComponent(); }
  }

  ngOnChanges(): void {
    if (this.readOnly && this.readStandard) { this.initializePublishedStandard(); }
  }

  private initializePublishedStandard(): void {
    if (!this.readStandard) { this.isLoaded = false; return; }
    this.thisStandard = Object.assign({}, this.readStandard);
    this.thisStandard.bindingGroup = this.thisStandard.bindingGroup || { name: EMPTY_READ_TEXT };
    this.thisStandard.initiator = this.thisStandard.initiator || this.thisStandard.author || { firstName: EMPTY_READ_TEXT, lastName: EMPTY_READ_TEXT };
    this.thisStandard.blanks = this.thisStandard.blanks || [];
    this.thisStandard.questions = this.thisStandard.questions ? Object.assign({}, this.thisStandard.questions) : null;
    this.thisStandard.ruPptId = this.thisStandard.ruPptId || this.thisStandard.ruPpt;
    this.ensureStandardQuestionsShape();
    this.newRuName = this.thisStandard.ruName;
    this.newEnName = this.thisStandard.enName;
    this.newRuAn = this.thisStandard.ruAnnotation;
    this.newEnAn = this.thisStandard.enAnnotation;
    this.isLoaded = true;
  }

  ngOnInit(): void {
    this.checkRole();
    if (this.readOnly) { this.initializePublishedStandard(); return; }
    this.stringDate = moment().format(STANDARD_DATE_FORMAT);
    this.thisStandard = this.stepsControllerService.getCurrentStandard();
    this.hasSaveAction = false;
    if (!this.thisStandard) { this.isLoaded = false; this.redirectToStandardsList(); return; }
    this.loadEditingChoices();
    this.standardTypesService.updateAllTypes();
    this.initializeEditingFields();
    if (this.isAdmin) { this.getUserTable(); }
    this.isLoaded = true;
  }

  ngAfterViewInit(): void {
    if (this.readOnly || !this.standardWindow) { return; }
    let host = this.standardWindow.nativeElement as HTMLElement;
    while (host && host.tagName !== WIZARD_HOST_TAG) { host = host.parentElement; }
    if (!host) { return; }
    const footers = host.getElementsByClassName(WIZARD_FOOTER_CLASS);
    for (let index = FIRST_WIZARD_FOOTER; index < WIZARD_FOOTER_COUNT; index++) {
      if (footers[index]) { footers[index].textContent = EMPTY_READ_TEXT; }
    }
  }

  private loadEditingChoices(): void {
    this.userService.getActiveUsers().takeUntil(this.publicationDestroyed$).subscribe(response => {
      this.errorMessage = false;
      if (response.status === HTTP_OK) { this.users = response.body; }
    }, () => this.errorMessage = true);
    this.adminService.getAllGroups().takeUntil(this.publicationDestroyed$).subscribe(response => {
      this.errorMessage = false;
      if (response.status === HTTP_OK) { this.groups = response.body; }
    }, () => this.errorMessage = true);
  }

  private initializeEditingFields(): void {
    this.ensureStandardQuestionsShape();
    this.newRuName = this.thisStandard.ruName;
    this.newEnName = this.thisStandard.enName;
    this.newRuAn = this.thisStandard.ruAnnotation;
    this.newEnAn = this.thisStandard.enAnnotation;
    this.loadAiQuestionStatus(AI_LANGUAGE_RUSSIAN);
    this.thisStandard.linkedUsers.forEach(user => this.selectItem(user));
    this.thisStandard.linkedGroups.forEach(group => this.selectGroupItem(group));
    this.thisStandard.linkedPositions.forEach(position => this.selectPosItem(position));
  }

  change(data) {
		this.flagNg = data;
    if(data === false) {
      this.getUserTable();
    }
	}

  getUserTable() {
    if (this.readOnly && !this.isAdmin) { return; }
    const currentStandard = this.stepsControllerService.getCurrentStandard();
    if (!currentStandard || !currentStandard.id) {
      this.finishUserTableLoading();
      return;
    }
    this.startUserTableLoading();
    this.stepsControllerService.getFamiliarizedInfo(currentStandard.id).subscribe(
      (response) => this.handleUserTableLoaded(response, currentStandard),
      () => this.finishUserTableLoading()
    );
  }

  private redirectToStandardsList(): void {
    if (this.isAdmin && !this.isHead) {
      this.router.navigate([STANDARD_LIST_ROUTES.admin]);
      return;
    }
    if (this.isAdmin && this.isHead) {
      this.router.navigate([STANDARD_LIST_ROUTES.adminHead]);
      return;
    }
    if (!this.isAdmin && this.isHead) {
      this.router.navigate([STANDARD_LIST_ROUTES.head]);
      return;
    }
    this.router.navigate([STANDARD_LIST_ROUTES.employee]);
  }

  private startUserTableLoading(): void {
    this.isLoaded = false;
    this.isLoadedStep = false;
  }

  private finishUserTableLoading(): void {
    this.isLoaded = true;
    this.isLoadedStep = true;
  }

  private handleUserTableLoaded(response: any, currentStandard: any): void {
    if (response.status !== 200) {
      this.finishUserTableLoading();
      return;
    }
    this.tableUsers = response.body || [];
    this.syncCurrentStandardStatus(currentStandard);
    this.showTable = this.tableUsers.length > 0;
    this.finishUserTableLoading();
  }

  private syncCurrentStandardStatus(currentStandard: any): void {
    if (!this.thisStandard || !currentStandard.status) {
      return;
    }
    this.thisStandard.status = currentStandard.status.toString();
  }

  deleteUserFromStnd(user: StandardFamiliarizationUser): void {
    if (this.readOnly) { return; }
    this.userRemoval.remove(this.thisStandard, user, users => this.acceptAssignedUsers(users));
  }

  acceptAssignedUsers(users: StandardFamiliarizationUser[]): void {
    if (this.readOnly) { return; }
    this.tableUsers = users;
    this.showTable = !!users.length;
  }

  checkRole() {
		this.user = this.userService.getLocal();
		if (this.user.roles.indexOf('ROLE_HEAD') !== -1) {
			this.isHead = true;
		} else {
			this.isHead = false;
		}
		if (this.user.roles.indexOf('ROLE_ADMIN') !== -1) {
			this.isAdmin = true;
		} else {
			this.isAdmin = false;
		}
		if (this.user.roles.indexOf('ROLE_USER') !== -1) {
			this.isUser = true;
		} else {
			this.isUser = false;
		}
	}

  isValid() {
    return (
      this.newRuName !== '' && this.newEnName !== '' &&
      this.newRuAn !== '' && this.newEnAn !== '' &&
      this.formData.has('RU_DOC') &&
      this.checkListsLength());
  }

  checkListsLength() {
    return (this.selectedGroupForExecute.length > 0
      || this.selectedForExecute.length > 0
      || this.selectedPosForExecute.length > 0);
  }

  setType(typeID) {
    if (this.readOnly) { return; }
    const typeObj = this.standardTypesService.getTypesList().find(i => i.id === typeID);
    this.standardTypesService.setSelectedType(typeObj);
    this.selectedType = typeObj;
  }

  // ПРОВЕРКА ВЫБРАН ЛИ ЭЛЕМЕНТ
  selectItem(user) {
    if (this.readOnly) { return; }
    if (this.isSelectedUser(user)) {
      const index = this.selectedForExecute.findIndex(x => x.id === user.id);
      if (index !== ITEM_NOT_FOUND) {
        this.selectedForExecute.splice(index, ONE_ITEM);
      }
    } else {
      this.selectedForExecute.push(user);
    }
  }

  selectPosItem(pos) {
    if (this.readOnly) { return; }
    if (this.isSelectedPos(pos)) {
      const index = this.selectedPosForExecute.findIndex(x => x.id === pos.id);
      if (index !== ITEM_NOT_FOUND) {
        this.selectedPosForExecute.splice(index, ONE_ITEM);
      }
    } else {
      this.selectedPosForExecute.push(pos);
    }
  }

  selectGroupItem(group) {
    if (this.readOnly) { return; }
    if (this.isSelectedGroup(group)) {
      const index = this.selectedGroupForExecute.findIndex(x => x.id === group.id);
      if (index !== ITEM_NOT_FOUND) {
        this.selectedGroupForExecute.splice(index, ONE_ITEM);
      }
    } else {
      this.selectedGroupForExecute.push(group);
    }
  }

  isSelectedUser(user) {
    this.foundUser = false;
    if (this.selectedForExecute.length > 0) {
      for (const grp of this.selectedForExecute) {
        if (grp !== null) {
          if (grp.id === user.id) {
            this.foundUser = true;
            break;
          }
        }
      }
    }
    return this.foundUser;
  }

  check() {
    if (!this.treeGroupPosService.areOperationTargetsReady()) { return false; }
    let a = true;
    this.newBlanks.forEach(item => {
      if(!item.name || !item.formData) {
        a = false;
      } else {
        a =  true;
      }
    })
    return a;
  }

  isSelectedPos(pos) {
    this.foundPos = false;
    if (this.selectedPosForExecute.length > 0) {
      for (const grp of this.selectedPosForExecute) {
        if (grp !== null) {
          if (grp.id === pos.id) {
            this.foundPos = true;
            break;
          }
        }

      }
    }
    return this.foundPos;
  }

  isSelectedGroup(group) {
    this.foundGroup = false;
    if (this.selectedGroupForExecute.length > 0) {
      for (const grp of this.selectedGroupForExecute) {
        if (grp !== null) {
          if (grp.id === group.id) {
            this.foundGroup = true;
            break;
          }
        }
      }
    }
    return this.foundGroup;
  }

  downloadFile(id) {
    this.userService.getFile(id).subscribe(
      (response: any) => {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(response.body);
        link.download = response.headers.get('filename');
        link.click();
        link.remove();
      },
      () => {
      }
    );
  }

  downloadReaderFile(id: string): void {
    this.readerMaterialFailed = false;
    this.userService.getFile(id).takeUntil(this.publicationDestroyed$).subscribe(
      (response: HttpResponse<Blob>) => downloadCatalogFile(response.body, response.headers.get(DOWNLOAD_FILENAME_HEADER)),
      () => this.readerMaterialFailed = true);
  }

  deleteBlankFile(blank, key) {
    if (this.readOnly) { return; }
    const modalRef = this.modalService.open(ConfirmationPopupComponent);
    modalRef.componentInstance.massage = DELETE_BLANK_FILE_CONFIRM;
    modalRef.result.then((result) => {
      if (result === CONFIRM_RESULT) {
        if (key > ITEM_NOT_FOUND) {
          this.thisStandard.blanks.splice(key, ONE_ITEM);
        }
        let obj = {
          fileId: blank.fileId
        }
        this.listDelBlanks.push(obj);
        // this.adminService.deleteBlankFromStandardTemp(blank, this.stepsControllerService.getTempParrentID()).subscribe(
        //   (response) => {
        //     if (response.status === 200) {
        //       const index = this.thisStandard.blanks.indexOf(blank);
        //       this.thisStandard.blanks.splice(index, 1);
        //     }
        //   },
        //   () => {
        //   }
        // );
      }
    });
  }

  openPdfStnd(fileId: string) {
    window.open(this.apiConnectService.getPdf + fileId, '_blank');
  }

  deleteFile(fileId: string, type: string): void {
    if (this.readOnly) { return; }
    const modalRef = this.modalService.open(ConfirmationPopupComponent);
    modalRef.componentInstance.massage = DELETE_STANDARD_CONFIRM;
    modalRef.result.then((result: string) => {
      if (result !== CONFIRM_RESULT) { return; }
      this.adminService.deleteFileFromStandardTemp(fileId, type, this.stepsControllerService.getTempParrentID())
        .takeUntil(this.publicationDestroyed$).subscribe(response => {
          if (response.status === HTTP_OK && TEMP_FILE_FIELDS[type]) { this.thisStandard[TEMP_FILE_FIELDS[type]] = null; }
        }, () => {});
    });
  }

  deleteFilePresentation(fileId: string, type: string) {
    if (this.readOnly) { return; }
    const modalRef = this.modalService.open(ConfirmationPopupComponent);
    modalRef.componentInstance.massage = DELETE_STANDARD_CONFIRM;
    modalRef.result.then((result: string) => {
      if (result === CONFIRM_RESULT) {
        this.thisStandard.ruPptId = null;
        this.fileRuPpt = null;
        this.isNewRuPpt = false;
      }
    });
  }

  deleteFileEdit(fileId: string, type: string) {
    if (this.readOnly) { return; }
    const modalRef = this.modalService.open(ConfirmationPopupComponent);
    modalRef.componentInstance.massage = DELETE_STANDARD_CONFIRM;
    modalRef.result.then((result: string) => {
      if (result === CONFIRM_RESULT) {
        this.thisStandard.ruFileLink = null;
        this.thisStandard.ruDocId = null;
        this.fileRuDoc = null;
        this.isNewRuDoc = false;
      }
    });
  }


  fileChange(typeFile: string, event: Event): void {
    if (this.readOnly) { return; }
    const files = (event.target as HTMLInputElement).files;
    const file = files && files[FIRST_SELECTED_FILE];
    if (typeFile === FILE_RU_DOC) {
      this.errorFHMsgTxt = !!file && file.name.slice(files.length - DOCUMENT_EXTENSION_OFFSET) !== DOCUMENT_EXTENSION;
      if (this.errorFHMsgTxt) { return; }
    }
    const metadata = STANDARD_FILE_METADATA[typeFile];
    if (!metadata) { return; }
    this[metadata.draft] = file || null;
    this[metadata.selected] = !!file;
  }

  uplodFileAfterEdit() {
    this.uploadPublicationFile(FILE_RU_DOC, this.fileRuDoc);
  }

  uplodFileAfterSave() {
    this.uploadPublicationFile(FILE_RU_PPT, this.fileRuPpt);
  }

  private uploadPublicationFile(type: string, file: File): void {
    if (this.readOnly) { return; }
    const body = new FormData();
    body.set(type, file, file.name);
    this.adminService.uploadFilesTemp(this.stepsControllerService.getTempParrentID(), body, this.thisStandard)
      .takeUntil(this.publicationDestroyed$).subscribe(
        () => this.readUploadedFile(type), error => this.failPublication(error)
      );
  }

  private readUploadedFile(type: string): void {
    this.adminService.getStandardTemp(this.stepsControllerService.getTempParrentID())
      .takeUntil(this.publicationDestroyed$).subscribe(
        response => this.acceptUploadedFile(type, response), error => this.failPublication(error)
      );
  }

  private acceptUploadedFile(type: string, response: HttpResponse<Object>): void {
    if (response.status !== HTTP_OK || !response.body) { this.failPublication({}); return; }
    this.isUploadDisabled = false;
    if (type === FILE_RU_DOC) {
      this.thisStandard.ruDocId = response.body[TEMP_DOCUMENT_LINK_FIELD];
      this.presaAfterSave();
    } else {
      this.thisStandard.ruPptId = response.body[TEMP_PRESENTATION_FIELD];
      this.blanksAfterSave();
    }
  }

  openDocModalDOCX(fileLink) {
    localStorage.setItem('fileLink', fileLink);

    const modalRef = this.modalService.open(ViewDocxComponent, { size: 'lg', backdrop: 'static' });
    modalRef.result.then((result) => {
      if (result === 'Close') {
        // on close button
        this.viewDocxService.deleteLinkByDocxIDManually();
      }
    }, () => {
      // on dismiss
      this.viewDocxService.deleteLinkByDocxIDManually();
    });

  }

  openReaderDocument(fileLink: string): void {
    this.openReaderViewer({fileId: null, standardId: null, fileLink});
  }

  openStoredDocument(fileId: string): void {
    this.openReaderViewer({fileId, standardId: this.thisStandard.id, fileLink: null});
  }

  private openReaderViewer(context: StandardDocumentContext): void {
    if (this.readerModal) { return; }
    storeDocumentContext(context);
    this.readerModal = this.modalService.open(ViewDocxComponent, {size: READER_MODAL_SIZE, backdrop: READER_MODAL_BACKDROP});
    const cleanup = () => {
      this.readerModal = null;
      storeDocumentContext({fileId: null, standardId: null, fileLink: null});
    };
    this.readerModal.result.then(cleanup, cleanup);
  }

  deleteFileDOCX(standardId: string, fileLink: string, ...fileDetails: string[]): void {
    if (this.readOnly) { return; }
    const type = fileDetails[FILE_TYPE_INDEX];
    const docId = fileDetails[FILE_ID_INDEX];
    this.adminService.deleteTempDocxFileManuallyTemp(fileLink, this.stepsControllerService.getTempParrentID())
      .takeUntil(this.publicationDestroyed$).subscribe(() => {
        const metadata = STANDARD_FILE_METADATA[type];
        if (metadata && metadata.link) {
          this.thisStandard[metadata.field] = null;
          this.thisStandard[metadata.link] = null;
        }
        if (docId) { this.deleteFile(docId, type); }
      }, () => {});
  }

  addNewBlank() {
    if (this.readOnly) { return; }
    this.newBlanks.push(new NewBlank(null, null, null));
    this.check();
  }

  cnhageBlankInfo(event, i){
    if (this.readOnly) { return; }
		this.newBlanks[i].name = event;
		this.newBlanks[i].number = this.thisStandard.number + BLANK_NUMBER_SEPARATOR + (this.thisStandard.blanks.length + this.newBlanks.length + ONE_ITEM);
	}

  blanksChange(event, index: number) {
    if (this.readOnly) { return; }
    const fileList = event.target.files;
    if (fileList.length > NO_ITEMS) {
      const file: File = fileList[NO_ITEMS];
      const formData = new FormData();
      formData.append(BLANK_FILE_FIELD, file, file.name);
      this.newBlanks[index].formData = formData;
    }
  }

  saveBlank() {
    if (this.readOnly) { return; }
    this.adminService.uploadBlankTemp(this.stepsControllerService.getTempParrentID(), this.newBlanks, this.thisStandard)
      .takeUntil(this.publicationDestroyed$).subscribe(
        response => { if (response.status === HTTP_OK) { this.tempSaveThisStandard(); } else { this.failPublication({}); } },
        error => this.failPublication(error)
      );
  }

  deleteBlank(key) {
    if (this.readOnly) { return; }
    const modalRef = this.modalService.open(ConfirmationPopupComponent);
    modalRef.componentInstance.massage = DELETE_BLANK_CONFIRM;
    modalRef.result.then((result) => {
      if (result === CONFIRM_RESULT) {
        if (key > ITEM_NOT_FOUND) {
          this.newBlanks.splice(key, ONE_ITEM);
        }
      }
    });
  }


  isSelectedUserForRemove(uID) {
    let foundForRemove = false;
    if (this.removedUsersIDList.length > 0) {
      for (const rID of this.removedUsersIDList) {
        if (rID === uID) {
          foundForRemove = true;
          break;
        }
      }
    }
    return foundForRemove;
  }

  get hasAiQuestionTarget(): boolean {
    return !!this.getAiQuestionTargetStandardId();
  }

  get isRussianAiQuestionLoading(): boolean {
    return this.isAiQuestionLoading(AI_LANGUAGE_RUSSIAN);
  }

  get russianAiQuestionStatusKey(): string {
    return this.getAiQuestionStatusKey(AI_LANGUAGE_RUSSIAN);
  }

  get russianGenerateAiQuestionButtonKey(): string {
    return this.getGenerateAiQuestionButtonKey(AI_LANGUAGE_RUSSIAN);
  }

  get isRussianAiQuestionStatusVisible(): boolean {
    return this.isAiQuestionLoading(AI_LANGUAGE_RUSSIAN)
      || this.aiQuestionStatusVisibleByLanguage[AI_LANGUAGE_RUSSIAN] === true;
  }

  loadAiQuestionStatus(language: StandardAiQuestionLanguage): void {
    if (this.readOnly) { return; }
    const standardId = this.getAiQuestionTargetStandardId();
    if (!standardId) { return; }
    this.aiQuestionStatusLoadingByLanguage[language] = true;
    this.aiQuestionStatusErrorByLanguage[language] = false;
    this.adminService.getStandardAiQuestionStatus(standardId, language).takeUntil(this.publicationDestroyed$)
      .subscribe((response: HttpResponse<StandardAiQuestionGenerationStatus>) => {
        this.aiQuestionStatusLoadingByLanguage[language] = false;
        if (standardId === this.getAiQuestionTargetStandardId()) { this.aiQuestionStatusByLanguage[language] = response.body; }
      }, () => {
        this.aiQuestionStatusLoadingByLanguage[language] = false;
        if (standardId === this.getAiQuestionTargetStandardId()) { this.aiQuestionStatusErrorByLanguage[language] = true; }
      });
  }

  onGenerateRussianAiQuestions(): void {
    if (this.readOnly) { return; }
    this.generateAiQuestions(AI_LANGUAGE_RUSSIAN);
  }

  private generateAiQuestions(language: StandardAiQuestionLanguage): void {
    this.requestAiQuestionGeneration(language);
  }

  private requestAiQuestionGeneration(language: StandardAiQuestionLanguage): void {
    const standardId = this.getAiQuestionTargetStandardId();
    if (!standardId) {
      return;
    }
    this.aiQuestionLoadingByLanguage[language] = true;
    this.aiQuestionGenerationErrorByLanguage[language] = false;
    this.aiQuestionStatusVisibleByLanguage[language] = true;
    this.adminService.generateExistingStandardDraftAiQuestions(standardId, language)
      .subscribe((response: HttpResponse<StandardAiQuestionGenerationStatus>) => {
      if (standardId !== this.getAiQuestionTargetStandardId()) {
        this.aiQuestionLoadingByLanguage[language] = false;
        return;
      }
      this.aiQuestionStatusByLanguage[language] = response.body;
      const hasGeneratedQuestions = response.body
        && response.body.status === 'SUCCEEDED'
        && response.body.questions
        && response.body.questions.length > 0;
      if (hasGeneratedQuestions) {
        this.applyDraftAiQuestions(response.body.questions);
      }
      this.aiQuestionGenerationErrorByLanguage[language] = !response.body
        || response.body.status === 'FAILED'
        || (response.body.status === 'SUCCEEDED' && !hasGeneratedQuestions);
      this.aiQuestionLoadingByLanguage[language] = false;
      this.showAiQuestionStatusTemporarily(language);
    }, () => {
      this.aiQuestionLoadingByLanguage[language] = false;
      this.aiQuestionGenerationErrorByLanguage[language] = true;
      this.showAiQuestionStatusTemporarily(language);
    });
  }

  private showAiQuestionStatusTemporarily(language: StandardAiQuestionLanguage): void {
    this.aiQuestionStatusVisibleByLanguage[language] = true;
    if (this.aiQuestionStatusHideTimers[language]) {
      clearTimeout(this.aiQuestionStatusHideTimers[language]);
    }
    this.aiQuestionStatusHideTimers[language] = setTimeout(() => {
      this.aiQuestionStatusVisibleByLanguage[language] = false;
      this.aiQuestionStatusHideTimers[language] = null;
    }, 4000);
  }

  private clearAiQuestionStatusTimers(): void {
    Object.keys(this.aiQuestionStatusHideTimers).forEach((language) => {
      if (this.aiQuestionStatusHideTimers[language]) {
        clearTimeout(this.aiQuestionStatusHideTimers[language]);
      }
    });
    this.aiQuestionStatusHideTimers = {};
  }

  private applyQuestionsFromStandard(standard: any): void {
    this.ensureStandardQuestionsShape();
    const russianQuestions = this.extractQuestionsByLanguage(standard, 'russian', 'russianQuestions');
    const englishQuestions = this.extractQuestionsByLanguage(standard, 'english', 'englishQuestions');
    if (russianQuestions) {
      this.thisStandard.questions.russian = russianQuestions;
      this.thisStandard.questions.english = russianQuestions.slice();
    } else if (englishQuestions) {
      this.thisStandard.questions.english = englishQuestions;
      this.thisStandard.questions.russian = englishQuestions.slice();
    }
    this.globalRusQuest = this.thisStandard.questions.russian;
    this.globalEngQuest = this.thisStandard.questions.english;

    const currentStandard = this.stepsControllerService.getCurrentStandard();
    if (currentStandard && currentStandard !== this.thisStandard) {
      if (!currentStandard.questions) {
        currentStandard.questions = { russian: [], english: [] };
      }
      currentStandard.questions.russian = this.thisStandard.questions.russian;
      currentStandard.questions.english = this.thisStandard.questions.english;
    }
  }

  private applyDraftAiQuestions(questions: any[]): void {
    this.ensureStandardQuestionsShape();
    this.thisStandard.questions.russian = questions || [];
    this.thisStandard.questions.english = this.thisStandard.questions.russian.slice();
    this.globalRusQuest = this.thisStandard.questions.russian;
    this.globalEngQuest = this.thisStandard.questions.english;

    const currentStandard = this.stepsControllerService.getCurrentStandard();
    if (currentStandard && currentStandard !== this.thisStandard) {
      if (!currentStandard.questions) {
        currentStandard.questions = { russian: [], english: [] };
      }
      currentStandard.questions.russian = this.thisStandard.questions.russian;
      currentStandard.questions.english = this.thisStandard.questions.english;
    }
  }

  private extractQuestionsByLanguage(standard: any, languageKey: string, legacyKey: string): any[] {
    if (standard && standard.questions && standard.questions[languageKey]) {
      return standard.questions[languageKey];
    }
    if (standard && standard[legacyKey]) {
      return standard[legacyKey];
    }
    return null;
  }

  private ensureStandardQuestionsShape(): void {
    if (!this.thisStandard) {
      return;
    }
    if (!this.thisStandard.questions) {
      this.thisStandard.questions = {
        russian: this.thisStandard.russianQuestions || [],
        english: this.thisStandard.englishQuestions || [],
      };
      return;
    }
    if (!this.thisStandard.questions.russian) {
      this.thisStandard.questions.russian = [];
    }
    if (!this.thisStandard.questions.english) {
      this.thisStandard.questions.english = [];
    }
  }

  private getAiQuestionTargetStandardId(): string {
    if (this.stepsControllerService.getTempParrentID && this.stepsControllerService.getTempParrentID()) {
      return this.stepsControllerService.getTempParrentID();
    }
    return this.thisStandard && this.thisStandard.id ? this.thisStandard.id : null;
  }

  private isAiQuestionLoading(language: StandardAiQuestionLanguage): boolean {
    return this.aiQuestionLoadingByLanguage[language] === true;
  }

  private getAiQuestionStatusKey(language: StandardAiQuestionLanguage): string {
    if (this.aiQuestionLoadingByLanguage[language]) {
      return 'STANDARD_AI_QUESTIONS_GENERATING';
    }
    if (this.aiQuestionGenerationErrorByLanguage[language]) {
      return 'STANDARD_AI_QUESTIONS_GENERATE_ERROR';
    }
    if (this.aiQuestionStatusLoadingByLanguage[language]) {
      return 'STANDARD_AI_QUESTIONS_STATUS_LOADING';
    }
    if (this.aiQuestionStatusErrorByLanguage[language]) {
      return 'STANDARD_AI_QUESTIONS_STATUS_UNAVAILABLE';
    }
    const status = this.aiQuestionStatusByLanguage[language];
    return status ? AI_STATUS_KEY_PREFIX + status.status : 'STANDARD_AI_QUESTIONS_STATUS_EMPTY';
  }

  private getGenerateAiQuestionButtonKey(language: StandardAiQuestionLanguage): string {
    if (this.isAiQuestionLoading(language)) {
      return 'STANDARD_AI_QUESTIONS_GENERATING';
    }
    return 'STANDARD_AI_QUESTIONS_GENERATE';
  }

  openNewQuestionsModal() {
    if (this.readOnly) { return; }
    const modalRef = this.modalService.open(AddNewQuestionsComponent);
    modalRef.componentInstance.setTempStandard(this.thisStandard);
  }

  openEditStandardNumberModal() {
    if (this.readOnly) { return; }
    const modalRef = this.modalService.open(EditStandardNumberPopupComponent);
    modalRef.componentInstance.initParams(
      this.stepsControllerService.getTempParrentID(),
      this.thisStandard.number
    );
    modalRef.result.then(
      (result) => {
        if (result && result.isSuccess) {
          this.thisStandard.number = result.newNumber;
        }
      },
      () => {}
    );
  }

  openEditQuestionModal(question: Question, lang: string) {
    if (this.readOnly) { return; }
    const modalRef = this.modalService.open(EditQuestionComponent);
    modalRef.componentInstance.initTemporaryParams(question, lang, this.thisStandard);
  }

  deleteQuestion(question: Question, lang: string) {
    if (this.readOnly) { return; }
    const modalRef = this.modalService.open(ConfirmationPopupComponent);
    modalRef.componentInstance.massage = DELETE_QUESTION_CONFIRM;
    modalRef.result.then((result) => {

      if (result === CONFIRM_RESULT) {
        if (lang === AI_LANGUAGE_RUSSIAN) {
          const index = this.thisStandard.questions.russian.indexOf(question);
          this.thisStandard.questions.russian.splice(index, ONE_ITEM);
          this.thisStandard.questions.english.splice(index, ONE_ITEM);
        } else if (lang === QUESTION_LANGUAGE_ENGLISH) {
          const index = this.thisStandard.questions.english.indexOf(question);
          this.thisStandard.questions.english.splice(index, ONE_ITEM);
          this.thisStandard.questions.russian.splice(index, ONE_ITEM);
        }
      }

    });
  }


  // -----------------------------------------------------------------------------------------------

  tempSaveThisStandard() {
    if (this.readOnly) { return; }
    this.disSaveBtn = true;
    this.hasSaveAction = false;
    const body = this.temporaryStandardBody();
    this.stepTempControllerService.saveTempStandard(body, this.stepsControllerService.getTempParrentID(), this.thisStandard)
      .takeUntil(this.publicationDestroyed$).subscribe(
        response => { if (response.status === HTTP_OK) { this.save(); } else { this.failPublication({}); } },
        error => this.failPublication(error)
      );
  }

  private temporaryStandardBody() {
    const type = this.standardTypesService.getSelectedType();
    return {
      blanks: this.listDelBlanks, number: this.thisStandard.number,
      ruName: this.newRuName, enName: this.newEnName, ruAnnotation: this.newRuAn, enAnnotation: this.newEnAn,
      standardType: { id: type.id, ruName: type.ruName, enName: type.enName },
      questions: this.temporaryQuestions(),
      linkedUsers: this.selectedReferences(this.selectedForExecute),
      linkedPositions: this.selectedReferences(this.selectedPosForExecute),
      linkedGroups: this.selectedReferences(this.selectedGroupForExecute),
      familiarizationDays: this.stepsControllerService.getEditActiveWithNotification() ? this.daysForFamiliarization : null,
      ruFileLink: this.thisStandard.ruDocId || this.thisStandard.ruFileLink,
      ruPptId: this.thisStandard.ruPptId, groupsWithPositions: this.treeGroupPosService.getReadeForServer()
    };
  }

  private selectedReferences(selected: { id: string }[]): { id: string }[] {
    return selected.filter(item => item !== null).map(item => ({ id: item.id }));
  }

  private temporaryQuestions() {
    const draft = this.stepTestingService.getQuestionList();
    return {
      russian: this.thisStandard.questions.russian.concat(draft.map(question => this.temporaryQuestion(question, LANGUAGE_RU))),
      english: this.thisStandard.questions.english.concat(draft.map(question => this.temporaryQuestion(question, LANGUAGE_EN)))
    };
  }

  private temporaryQuestion(question, language: string) {
    const answers = ANSWER_PREFIXES.map(prefix => ({ answerText: question.answers[FIRST_ANSWERS][prefix + language] }));
    const rightAnswer = answers[ANSWER_INDEX[question[RIGHT_ANSWER_PREFIX + language]]];
    return { questionText: question[QUESTION_TEXT_PREFIX + language], answers,
      rightAnswer: { answerText: rightAnswer && rightAnswer.answerText } };
  }


  // -----------------------------------------------------

  goToStandardsListTemp() {
    if (this.readOnly) { this.redirectToStandardsList(); return; }
    this.stepTestingService.clearQuestions();
    this.stepsControllerService.leaveComponent();
    if(this.isAdmin && !this.isHead) {
      this.router.navigate([STANDARD_LIST_ROUTES.admin]);
    }
    if(this.isAdmin && this.isHead) {
      this.router.navigate([STANDARD_LIST_ROUTES.adminHead]);
    }
    if(!this.isAdmin && this.isHead) {
      this.router.navigate([STANDARD_LIST_ROUTES.head]);
    }
  }


  saveStandard(): void {
    if (this.readOnly) { return; }
    if (this.publicationPending || this.versionConflict || this.userRemoval.pending || this.userRemoval.requiresReload
      || !this.treeGroupPosService.areOperationTargetsReady()) { return; }
    this.publishStandard();
  }

  publishStandard() {
    if (this.readOnly) { return; }
    if (this.publicationPending || this.versionConflict || this.userRemoval.pending || this.userRemoval.requiresReload) { return; }
    this.successFMsg = false;
    this.errorFHMsg = false;
    this.errorUnknowMsg = false;
    this.errorNoUsersMsg = false;
    this.publicationPending = true;
    this.hasSaveAction = false;
    const modalRef = this.modalService.open(AddChanglogComponent);
    const changeLog = modalRef.componentInstance;
    changeLog.setModalLogWindow(modalRef);
    changeLog.changeLog = this.publicationNote;
    modalRef.result.then(result => this.continuePublication(result, changeLog.changeLog),
      () => this.publicationPending = false);
  }

  private continuePublication(result: string, note: string): void {
    if (this.publicationDestroyed) { return; }
    if (result !== CHANGE_LOG_CONTINUE) { this.publicationPending = false; return; }
    this.publicationNote = note;
    if (this.fileRuDoc) { this.uplodFileAfterEdit(); } else { this.presaAfterSave(); }
  }

presaAfterSave() {
  if (this.readOnly) { return; }
  if(this.fileRuPpt) {
    this.uplodFileAfterSave(); 
  } else {
    this.blanksAfterSave();
  }
}

blanksAfterSave() {
    if (this.readOnly) { return; }
    if(this.newBlanks.length > NO_ITEMS) {
      this.saveBlank();
    } else {
      this.tempSaveThisStandard();
    }
  }

  save() {
    if (this.readOnly) { return; }
    const note = this.publicationNote;
    if (!note || !note.trim()) { this.failPublication({}); return; }
    const id = this.stepsControllerService.getTempParrentID();
    const request = this.stepsControllerService.getEditActiveWithNotification()
      ? this.stepsControllerService.publishStandardWithNotify(id, { note })
      : this.stepsControllerService.publishStandardNoNotify(id, { note });
    request.takeUntil(this.publicationDestroyed$).subscribe(
      response => this.completePublication(response), error => this.failPublication(error)
    );
  }

  private completePublication(response: HttpResponse<Object>): void {
    if (response.status !== HTTP_OK) { this.failPublication({}); return; }
    this.publicationPending = false;
    this.disSaveBtn = false;
    this.successFMsg = true;
    this.changeLogStorage.clear();
    this.goToStandardsListTemp();
  }

  private failPublication(error): void {
    this.publicationPending = false;
    this.disSaveBtn = false;
    this.isLoaded = true;
    this.isUploadDisabled = false;
    this.successFMsg = false;
    this.errorUnknowMsg = true;
    this.versionConflict = isStandardVersionConflict(error);
  }

  reloadPublication(): void {
    if (this.readOnly) { return; }
    if (this.publicationPending || this.userRemoval.pending) { return; }
    this.publicationPending = true;
    this.reloadFailed = false;
    const parentId = this.stepsControllerService.getTempParrentID();
    const request = parentId ? this.adminService.getTempStandard(parentId) : this.adminService.getStandard(this.thisStandard.id);
    request.takeUntil(this.publicationDestroyed$).subscribe(
        response => this.acceptPublicationReload(response),
        () => { this.publicationPending = false; this.reloadFailed = true; }
      );
  }

  private acceptPublicationReload(response: HttpResponse<Object>): void {
    this.publicationPending = false;
    if (response.status !== HTTP_OK || !response.body) { this.reloadFailed = true; return; }
    this.thisStandard = Object.assign({}, response.body);
    if (this.stepsControllerService.getTempParrentID()) { this.thisStandard.status = EDITING_STATUS; }
    const version = savedStandardVersion(response);
    if (version != null) { this.thisStandard.version = version; }
    this.stepsControllerService.currentStandard = this.thisStandard;
    this.resetPublicationDraft();
    this.userRemoval.reset();
    this.versionConflict = false;
    this.errorUnknowMsg = false;
    this.ensureStandardQuestionsShape();
    this.standardTypesService.setSelectedType(this.thisStandard.standardType);
    if (this.assignmentEditor) { this.assignmentEditor.reloadStoredSelections(); }
    this.getUserTable();
  }

  private resetPublicationDraft(): void {
    this.publicationNote = EMPTY_CHANGE_LOG;
    this.newRuName = this.thisStandard.ruName;
    this.newEnName = this.thisStandard.enName;
    this.newRuAn = this.thisStandard.ruAnnotation;
    this.newEnAn = this.thisStandard.enAnnotation;
    this.selectedForExecute = this.thisStandard.linkedUsers.slice();
    this.selectedGroupForExecute = this.thisStandard.linkedGroups.slice();
    this.selectedPosForExecute = this.thisStandard.linkedPositions.slice();
    this.newBlanks = [];
    this.listDelBlanks = [];
    this.daysForFamiliarization = this.thisStandard.familiarizationDays || DEFAULT_FAMILIARIZATION_DAYS;
    this.fileRuDoc = this.fileRuPpt = this.fileRuPdf = null;
    this.fileEnDoc = this.fileEnPpt = this.fileEnPdf = null;
    this.stepTestingService.clearQuestions();
    this.changeLogStorage.clear();
  }

  shBlock(s) {
    switch (s) {
      case 'saq':
        this.showAddQuestions = !this.showAddQuestions;
        break;
      case 'sq':
        this.showQestions = !this.showQestions;
        break;
      case 'sds':
        this.showDessiminStn = !this.showDessiminStn;
        break;
      case 'scl':
        this.showChangeLog = !this.showChangeLog;
        break;
      case 'sfab':
        this.showFilesAndBlanks = !this.showFilesAndBlanks;
        break;
      case 'sau':
        this.showChangeLogs = !this.showChangeLogs;
        break;
      case 'stou':
        this.showUserFTable = !this.showUserFTable;
        break;
    }
  }

  onChange() {
    if (this.daysForFamiliarization < 1) {
      this.daysForFamiliarization = 1;
    }
  }

    // uploadFile(typeFile) {
  //   this.isUploadDisabled = true;
  //   if (typeFile === 'RU_PDF') {
  //     const formData: FormData = new FormData();
  //     formData.set(typeFile, this.fileRuPdf, this.fileRuPdf.name);
  //     this.adminService.uploadFilesTemp(this.stepsControllerService.getTempParrentID(), formData).subscribe(
  //       () => {
  //         this.adminService.getStandardTemp(this.stepsControllerService.getTempParrentID()).subscribe(
  //           (response: any) => {
  //             this.thisStandard.ruPdfId = response.body.ruPdfId;
  //             this.isUploadDisabled = false;
  //           },
  //           () => {
  //             this.isUploadDisabled = false;
  //           }
  //         );
  //       }, () => {
  //         this.isUploadDisabled = false;
  //       }
  //     );
  //   }
  //   if (typeFile === 'EN_PDF') {
  //     const formData: FormData = new FormData();
  //     formData.set(typeFile, this.fileEnPdf, this.fileEnPdf.name);
  //     this.adminService.uploadFilesTemp(this.stepsControllerService.getTempParrentID(), formData).subscribe(
  //       () => {
  //         this.adminService.getStandardTemp(this.stepsControllerService.getTempParrentID()).subscribe(
  //           (response: any) => {
  //             this.thisStandard.enPdfId = response.body.enPdfId;
  //             this.isUploadDisabled = false;
  //           },
  //           () => {
  //             this.isUploadDisabled = false;
  //           }
  //         );
  //       }, () => {
  //         this.isUploadDisabled = false;
  //       }
  //     );
  //   }
  //   if (typeFile === 'EN_DOC') {
  //     const formData: FormData = new FormData();
  //     formData.set(typeFile, this.fileEnDoc, this.fileEnDoc.name);
  //     this.adminService.uploadFilesTemp(this.stepsControllerService.getTempParrentID(), formData).subscribe(
  //       () => {
  //         this.adminService.getStandardTemp(this.stepsControllerService.getTempParrentID()).subscribe(
  //           (response: any) => {
  //             this.thisStandard.enDocId = response.body.enDocId;
  //             this.thisStandard.enPdfId = response.body.enPdfId;
  //             this.thisStandard.enFileLink = response.body.enFileLink;
  //             this.isUploadDisabled = false;
  //           },
  //           () => {
  //             this.isUploadDisabled = false;
  //           }
  //         );
  //       },
  //       () => {
  //         this.isUploadDisabled = false;
  //       }
  //     );
  //   }
  //   if (typeFile === 'EN_PPT') {
  //     const formData: FormData = new FormData();
  //     formData.set(typeFile, this.fileEnPpt, this.fileEnPpt.name);
  //     this.adminService.uploadFilesTemp(this.stepsControllerService.getTempParrentID(), formData).subscribe(
  //       () => {
  //         this.adminService.getStandardTemp(this.stepsControllerService.getTempParrentID()).subscribe(
  //           (response: any) => {
  //             this.thisStandard.enPptId = response.body.enPptId;
  //             this.isUploadDisabled = false;
  //           },
  //           () => {
  //             this.isUploadDisabled = false;
  //           }
  //         );
  //       },
  //       () => {
  //         this.isUploadDisabled = false;
  //       }
  //     );
  //   }
  // }

}




// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/create-operating-standard/opst-step-eight/opst-step-eight.component.ts